module.exports = __webpack_public_path__ + "static-portal/img/6.c10eb8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/6.jpg
// module id = DeB9
// module chunks = 4